<template>
  <div class="not-found">
    <h1>404</h1>
    <h2>页面未找到</h2>
    <p>抱歉，您访问的页面不存在。</p>
    <router-link to="/" class="home-link">返回首页</router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background-color: #f9f9f9;
}

h1 {
  font-size: 5rem;
  color: #ff4d4f;
}

h2 {
  font-size: 2rem;
  margin: 10px 0;
}

p {
  font-size: 1.2rem;
  margin-bottom: 20px;
}

.home-link {
  padding: 10px 20px;
  background-color: #1890ff;
  color: white;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s;
}

.home-link:hover {
  background-color: #40a9ff;
}
</style> 